import { useTheme } from '../../contexts/ThemeContext';

interface ChatMessageProps {
  role: 'user' | 'assistant';
  content: string;
  isStreaming?: boolean;
}

const TypingIndicator = () => (
  <div className="flex items-center gap-1 py-1">
    <span className="typing-dot w-2 h-2 rounded-full bg-gray-400" style={{ animationDelay: '0ms' }} />
    <span className="typing-dot w-2 h-2 rounded-full bg-gray-400" style={{ animationDelay: '150ms' }} />
    <span className="typing-dot w-2 h-2 rounded-full bg-gray-400" style={{ animationDelay: '300ms' }} />
  </div>
);

const ChatMessage = ({ role, content, isStreaming }: ChatMessageProps) => {
  const { theme } = useTheme();

  if (role === 'user') {
    return (
      <div className="flex justify-end mb-3">
        <div className="max-w-[80%] px-4 py-2.5 rounded-2xl rounded-br-md text-white bg-gradient-to-r from-blue-500 to-blue-600 text-sm leading-relaxed whitespace-pre-wrap">
          {content}
        </div>
      </div>
    );
  }

  return (
    <div className="flex justify-start mb-3">
      <div
        className="max-w-[80%] px-4 py-2.5 rounded-2xl rounded-bl-md text-sm leading-relaxed whitespace-pre-wrap"
        style={{
          backgroundColor: theme === 'dark' ? '#374151' : '#f3f4f6',
          color: 'var(--text-primary)',
        }}
      >
        {content || (isStreaming && <TypingIndicator />)}
        {content && isStreaming && (
          <span className="inline-block w-1.5 h-4 ml-0.5 bg-current opacity-75 animate-pulse align-text-bottom" />
        )}
      </div>
    </div>
  );
};

export default ChatMessage;
